// The server redirects read the JSON file too.
import appPaths from './app-paths.json'

/** Top-level app paths that hold no event id. */
export const APP_PATHS = appPaths
